'use strict';

var promisify = require('promisify-es6');

var streamToValueWithTransformer = require('../utils/stream-to-value-with-transformer');

var multiaddr = require('multiaddr');

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var errcode = require('err-code');

module.exports = function (send) {
  return promisify(function (peerId, opts, callback) {
    if (typeof opts === 'function' && !callback) {
      callback = opts;
      opts = {};
    } // opts is the real callback --
    // 'callback' is being injected by promisify


    if (typeof opts === 'function' && typeof callback === 'function') {
      callback = opts;
      opts = {};
    }

    var handleResult = function handleResult(res, callback) {
      // Inconsistent return values in the browser
      if (Array.isArray(res)) {
        res = res.find(function (r) {
          return r.Type === 2;
        });
      } // Type 2 keys
      // 2 = FinalPeer
      // https://github.com/libp2p/go-libp2p-core/blob/6e566d10f4a5447317a66d64c7459954b969bdab/routing/query.go#L18


      if (!res || res.Type !== 2) {
        var errMsg = "key was not found (type 4)";
        return callback(errcode(new Error(errMsg), 'ERR_KEY_TYPE_4_NOT_FOUND'));
      }

      var responseReceived = res.Responses[0];
      var peerInfo = new PeerInfo(PeerId.createFromB58String(responseReceived.ID));
      responseReceived.Addrs.forEach(function (addr) {
        var ma = multiaddr(addr);
        peerInfo.multiaddrs.add(ma);
      });
      callback(null, peerInfo);
    };

    send({
      path: 'dht/findpeer',
      args: peerId.toString(),
      qs: opts
    }, function (err, result) {
      if (err) {
        return callback(err);
      }

      streamToValueWithTransformer(result, handleResult, callback);
    });
  });
};